module.exports = __webpack_public_path__ + "img/popup-bg.1b61e672.png";